import {
    Checkbox,
    Chip,
    chipClasses,
    TableCell,
    TableRow,
    Tooltip,
    Hidden
} from "@mui/material";
import {Authorizations, hasAuthorization} from "../../../utils/authorizations";
import {getFirstProductImage} from "../../../utils/getFirstProductImage";
import {ImageSharp} from "@mui/icons-material";
import CustomDate from "../../../components/date/date";
import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import listStyle from "../../../assets/jss/views/product/listStyle";
import {FormattedMessage, injectIntl} from "react-intl";
import {sortOn} from "../../../utils/sortOn";
import FormattedNumberWithCurrency from "../../../components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import {marketPlaceOffer} from "../../enum/offers";
import {handleSelectProduct} from "../../../actions/product/selection";
import {UserAgentUtils} from "../../../utils/useragent";
import {getTranslation} from "../../helpers/translations";
import {withStyles} from "@mui/styles";
import ProductBrandLabel from "./molecule/ProductBrandLabel";

class ProductRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelected: false,
        }
    }

    renderName = (name, id, sku, eshop) => {
        const {classes} = this.props;

        return (
            <div>
                <div>
                    <span className={classes.name}>{name}</span>
                </div>
                {this.props.offer === marketPlaceOffer && (
                    <Hidden smDown>
                        <div className={classes.nameInfos}>
                            <div>
                                <span>SKU: {sku}</span>
                            </div>

                            {eshop &&
                            <div>
                                <span>eShop ID: {eshop}</span>
                            </div>
                            }
                        </div>
                    </Hidden>
                )}
            </div>
        );
    };

    renderCategories = (categories) => {
        const {classes} = this.props;

        return (
            <div>
                {categories.sort(sortOn("name")).map(category => {
                    return (
                        <Tooltip title={getTranslation(category).name}>
                            <Chip key={category.id} label={getTranslation(category).name} className={category.draft ? classes.categoryDraft : classes.category} />
                        </Tooltip>
                    )
                })}
            </div>
        )
    };

    renderStock = (offer, status, stocks) => {
        const {classes} = this.props;
        let stockType;
        let sizeChip = [];
        let statusChip;
        let trad;

        if (offer === marketPlaceOffer) {
            statusChip =
                <Chip
                    label={<FormattedMessage
                        id={status ? "retailer.product.list.label.active" : "retailer.product.list.label.inactive"}/>}
                    className={status ? classes.status : classes.statusOff}
                    variant="outlined"
                    size="small"
                />;
        }

        if (Object.keys(stocks).length > 0) {
            for (let stock in stocks) {
                if (stocks[stock]['count'] === 0) {
                    continue
                }

                if (stock === 'out-of-stock') {
                    stockType = classes.noStock
                    trad = 'retailer.product.list.row.stock.out-of-stock'
                } else if (stock === 'mid-stock') {
                    stockType = classes.middleStock
                    trad = 'retailer.product.list.row.stock.mid-stock'
                } else {
                    stockType = classes.inStock
                    trad = 'retailer.product.list.row.stock.in-stock'
                }

                sizeChip.push(
                    <Tooltip title={<FormattedMessage id={"retailer.product.list.row.stock.variation_count"} values={{disabled: stocks[stock]['count_disabled']}}/>}>
                        <Chip
                            key={stock}
                            label={
                                <>
                                    <div
                                        className={stocks[stock]['count_disabled'] === 0 ? classes.stockBadgeOnline : classes.stockBadgeOffline}></div>
                                    <FormattedMessage id={trad} values={{stock: stocks[stock]['count']}}/>
                                </>
                            }
                            className={stockType}
                            size="small"
                            sx={{[`& .${chipClasses.icon}`]: {
                                color: "#ffffff"
                            }}}
                        />
                    </Tooltip>);
            }
        }

        return (
            <div className={classes.stockStatus}>
                {offer === marketPlaceOffer &&
                    <div>
                        {statusChip}
                    </div>
                }
                <div className={classes.stock}>
                    {sizeChip}
                </div>
            </div>
        );
    };

    renderPrice = (highestPrice, lowestPrice) => {
        const {classes} = this.props;

        return (
            <div>
                <div className={classes.price}>
                    <FormattedNumberWithCurrency value={lowestPrice} currency={this.props.currentOrganization?.currency} />
                </div>
                <div className={classes.xsPrice}>
                    <FormattedNumberWithCurrency value={highestPrice} currency={this.props.currentOrganization?.currency} />
                </div>
            </div>
        );
    };

    displayErrorOnPushWarning(product) {
        const { classes, intl } = this.props;

        if (product.errorOnPush && product.lastErrorDate > product.updatedAt) {
            return (
                <Tooltip title={intl.formatMessage({id: "retailer.product.list.label.errorOnPush"})}>
                    <span className={classes.errorOnPush}></span>
                </Tooltip>
            )
        }
    }

    displayValidation(offer, product, classes) {
        if (offer === marketPlaceOffer) {
            return (
                <Hidden smDown>
                    <TableCell>
                        {product.validated ?
                            <span className={classes.validated}>ok</span> :
                            <Tooltip title={product.validationErrors}>
                                <span className={classes.notValidated}>ko</span>
                            </Tooltip>
                        }
                        {this.displayErrorOnPushWarning(product)}
                    </TableCell>
                </Hidden>
            );
        }
    }

    handleSelect = (item, selected) => {
        this.props.handleSelectProduct(item, selected);
    }


    handleEditProduct = (event, product, currentPage, currentOrderBy) => {
        if (window.getSelection().toString().length > 0) {
            return;
        }

        const hasAuth = hasAuthorization(this.props.authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT) ||
            hasAuthorization(this.props.authorizations, Authorizations.STOCK_EASY_ACCESS);

        if (!hasAuth) {
            return;
        }

        const url = `${this.props.baseParamsUrl + this.props.match.params.id}/products/show/${product.id}`;
        if (event.metaKey || event.ctrlKey) {
            window.open(url, '_blank');
        } else {
            this.props.history.push({
                pathname: url,
                currentPage: currentPage,
                currentOrderBy: currentOrderBy,
                type: "parent",
            });
        }
    }

    render() {
        const product = this.props.product;
        const classes = this.props.classes;
        const currentPage = this.props.currentPage;
        const currentOrderBy = this.props.currentOrderBy;
        const isSelected = this.state.isSelected;
        const selected = this.props.selected;
        let hasHover = false;

        if (hasAuthorization(this.props.authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT) || hasAuthorization(this.props.authorizations, Authorizations.STOCK_EASY_ACCESS)) {
            hasHover = true;
        }

        return (
            <TableRow
                onClick={(e) => this.handleEditProduct(e, product, currentPage, currentOrderBy)}
                hover={hasHover}
                tabIndex={-1}
                key={product.id}
                aria-checked={isSelected}
                selected={isSelected}
                classes={{hover: classes.tableRowHover}}
            >
                {!UserAgentUtils.isMobile() && <TableCell>
                    {(false === product.eikow || this.props.offer === marketPlaceOffer) && (
                    <Checkbox
                        checked={this.props.isChecked}
                        classes={{
                            root: classes.checkbox,
                            checked: classes.checked
                        }}
                        color={"primary"}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.handleSelect(product, selected)
                        }}
                    />)}
                </TableCell>}
                <TableCell className={classes.imageCell + UserAgentUtils.isMobile() ? ' ' + classes.tableCell : ''} >
                    {product.pictures.length > 0 ?
                        <img
                            alt="product_image"
                            src={getFirstProductImage(product.pictures)}
                            className={classes.image}
                        /> :
                        <ImageSharp color={"disabled"} className={classes.imagePlaceholder}/>
                    }
                </TableCell>
                <Hidden smDown>
                    <TableCell className={classes.brandCell}>
                        <ProductBrandLabel
                            brand={product.brand}
                            isEikowProduct={product.eikow}
                            hasVariationFromFeed={product.variationFromFeed}
                        />
                    </TableCell>
                </Hidden>
                <TableCell className={UserAgentUtils.isMobile() ? classes.tableCell : ''}>
                    {this.renderName(getTranslation(product).name, product.externalId, product.sku, product.eshopId)}
                </TableCell>
                <Hidden smDown>
                    <TableCell className={classes.categoryContainer}>
                        {this.renderCategories(product.categories)}
                    </TableCell>
                </Hidden>
                <Hidden smDown>
                    <TableCell>
                        <CustomDate showRelativeDate={true} date={product.updatedAt} />
                    </TableCell>
                </Hidden>
                <Hidden smDown>
                    <TableCell>
                        {this.renderPrice(product.highestPrice, product.lowestPrice, product.currency.code)}
                    </TableCell>
                </Hidden>
                <Hidden smDown>
                    <TableCell className={classes.priceCell}>
                        {this.renderStock(this.props.offer, product.status, product.stocks)}
                    </TableCell>
                </Hidden>
                    {this.displayValidation(this.props.offer, product, classes)}
            </TableRow>
        );
    }
}

ProductRow.propTypes = {
    classes: PropTypes.object.isRequired,
    selected: PropTypes.array,
};

const mapStateToProps = state => {
    return {
        authorizations: state.authentication.authorizations,
        retailer: state.retailer.show.retrieved,
        selected: state.product.selection.selected,
        isSelectAll: state.product.selection.isSelectAll,
        currentOrganization: state.currentOrganization.retrieved ?? null,
    };
};

const mapDispatchToProps = dispatch => ({
    handleSelectProduct: (product, selected) => dispatch(handleSelectProduct(product, selected)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(listStyle)(injectIntl(ProductRow)));
